import Layout from "../../../components/layout/Layout/Layout";
import Header from "../../../components/layout/Header/Header";
import { getTop100Wines } from "../../../lib/wineRankingRequest";
import WinesTopPage from "../../../components/layout/WinesTop/WinesTopPage";
import BaseWineSearchBar from "../../../components/global/SearchBar/BaseWineSearchBar";
import { WineTopProps } from "../../../utils/wineRanking";
import { formatTitle } from "../../../utils/helper";
import Head from "next/head";

interface ITopWinesPageProps {
  topWinesInfo: WineTopProps;
}

export default function TopWinesPage({ topWinesInfo }: ITopWinesPageProps) {
  return (
    <Layout disableMeta>
      <Head>
        <title>{formatTitle(`${topWinesInfo.title}`)}</title>
        <meta
          name="description"
          content={`List of top wine selections ranked and curated by Vinous critics.`}
        />
        <meta
          name="keywords"
          content={`top wines, wine rankings, Vinous top wines`}
        />
        <link
          rel="canonical"
          href={`https://vinous.com/wines/lists/${topWinesInfo.slug}`}
        />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="google-translate-customization"
          content="bc9c404857e6094b-bd2091ef6a1aacc6-g5523c9461670c8e8-21"
        />
      </Head>
      <Header />
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <WinesTopPage
        title={topWinesInfo.title}
        description={topWinesInfo.description}
        slug={topWinesInfo.slug}
        wines={topWinesInfo.wines}
        author={topWinesInfo.author}
        issueDate={topWinesInfo.issueDate}
        imageUrl={topWinesInfo.imageUrl}
        subscribersOnly={topWinesInfo.subscribersOnly}
      />
    </Layout>
  );
}

export const getServerSideProps = async (context) => {
  try {
    if (!context.params || !context.params.slug) {
      return { notFound: true };
    }
    const { slug } = context.params;
    const { data } = await getTop100Wines(slug?.[0]);

    if (data?.published === false) {
      return {
        redirect: { destination: "/", permanent: false },
      };
    }

    if (data) {
      const topWinesInfo = {
        title: data.title,
        description: data.description,
        slug: data.slug,
        author: data.author,
        issueDate: data.issue_date,
        subscribersOnly: data.subscribers_only,
        imageUrl: data.image_url,
        wines: data.wines_ranking.map((entry) => ({
          id: entry.wine.wine_ranking.id,
          wineName: entry.wine.wine_ranking.wine_name,
          rank: entry.position,
          scoreRaw: entry.wine.wine_ranking.score_raw,
          price: entry.wine.wine_ranking.price,
          slug: entry.wine.wine_ranking.slug,
          vintage: entry.wine.wine_ranking.vintage,
          tastingNote: entry.wine.wine_ranking.tasting_note,
          author: entry.wine.wine_ranking.author,
          tastedOn: entry.wine.wine_ranking.tasted_on,
          producerName: entry.wine.wine_ranking.producer_name,
          thumbnailUrl: entry.thumbnail_url,
          extraNote: entry.extra_note,
          overwriteWineName: entry.overwrite_wine_name,
          region2: entry.wine.wine_ranking.region_2,
          country: entry.wine.wine_ranking.country,
          color: entry.wine.wine_ranking.color,
        })),
      };

      return {
        props: { topWinesInfo },
      };
    } else {
      return { notFound: true };
    }
  } catch (error) {
    return { notFound: true };
  }
};
